import axios from "axios";
import { api } from "../http";
import { ApiResponse, StudentRegistrationData } from "../types";

export interface CreateRazorpayOrderRequest {
  studentDetailsId?: number;
  amount: number;
  validityFrom: string;
  validityTo: string;
  purpose: "membership" | "registration";
}

export interface RazorpayOrderResponse {
  orderId: string;
  amount: number;
  currency: string;
  keyId: string;
  receiptNumber: string;
  companyName: string;
}

export interface VerifyRazorpayPaymentRequest {
  razorpayOrderId: string;
  razorpayPaymentId: string;
  razorpaySignature: string;
}

export interface VerifiedRazorpayPaymentResponse {
  studentDetailsId: number;
  amount: number;
  validityFrom: string;
  validityTo: string;
  razorpayOrderId: string;
}

export const createRazorpayOrder = async (
  request: CreateRazorpayOrderRequest
): Promise<ApiResponse<RazorpayOrderResponse>> => {
  const response = await api.post<ApiResponse<RazorpayOrderResponse>>(
    "/Payment/create-order",
    {
      studentDetailsId: request.studentDetailsId,
      amount: request.amount,
      validityFrom: request.validityFrom,
      validityTo: request.validityTo,
      purpose: request.purpose,
    }
  );
  return response.data;
};

const appendRegistrationForm = (
  form: FormData,
  student: StudentRegistrationData
) => {
  form.append("FirstName", student.firstName);
  form.append("LastName", student.lastName);
  form.append("EmailId", student.emailId);
  form.append("AadharNumber", student.aadharNumber.replace(/\s/g, ""));
  form.append("OptionalIdentification", student.optionalIdentification ?? "");
  form.append("MobileNumber", student.mobileNumber);
  form.append("AlternateNumber", student.alternateNumber ?? "");
  form.append("GuardianName", student.guardianName);
  form.append("GuardianMobileNumber", student.guardianMobileNumber);
  form.append("GenderCode", student.genderCode);
  form.append("Address", student.address);
  form.append("JoiningDate", student.joiningDate);
  if (student.amount) {
    form.append("Amount", student.amount);
  }
  if (student.validityFrom) {
    form.append("ValidityFrom", student.validityFrom);
  }
  if (student.validityTo) {
    form.append("ValidityTo", student.validityTo);
  }
  if (student.photo) {
    form.append("Photo", student.photo);
  }
};

export const createRegistrationOrder = async (
  student: StudentRegistrationData
): Promise<ApiResponse<RazorpayOrderResponse>> => {
  const form = new FormData();
  appendRegistrationForm(form, student);

  try {
    const response = await api.post<ApiResponse<RazorpayOrderResponse>>(
      "/Payment/create-registration-order",
      form
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data) {
      return error.response.data as ApiResponse<RazorpayOrderResponse>;
    }
    throw error;
  }
};

export const verifyRazorpayPayment = async (
  request: VerifyRazorpayPaymentRequest
): Promise<ApiResponse<VerifiedRazorpayPaymentResponse>> => {
  const response = await api.post<ApiResponse<VerifiedRazorpayPaymentResponse>>(
    "/Payment/verify",
    {
      razorpayOrderId: request.razorpayOrderId,
      razorpayPaymentId: request.razorpayPaymentId,
      razorpaySignature: request.razorpaySignature,
    }
  );
  return response.data;
};
